<template>
  <div>
    <van-cell-group class="navShow">
			<van-row>
				<van-col :span="2">			
					<van-icon name="arrow-left" color="#fff" @click="$router.go(-1)"/>
				</van-col>
				<van-col :span="20">应用管理</van-col>
				<van-col :span="2"></van-col>
			</van-row>
		</van-cell-group>
		<van-cell-group class="dangerWorkList">
      <div class="colContent">
        <div class="dangerWork" v-for="(item,index) in menuList" :key="item.value"  @click="toDangerWork(item)">
          <img :src="require(`../../assets/images/management/${item.value}.png`)" alt="" height="75%">
          {{item.label}}
          <van-icon class="itemDetail" name="arrow" color="#ccc" @click="toDangerWork(item)"/>
        </div>
      </div>
		</van-cell-group>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  export default {
    name: '',

    props: {
    },

    data () {
      return {
        menuList:[],//危险作业列表
      }
    },

    components: {
      
    },

    created() {
      
    },

    mounted() {
      this.leftTree()
      //this.getDangerWorkNum()
    },

    methods: {
      ...mapActions(['leftTree']),
      getDangerWorkNum(){
        let _that  =this
        this.$axios.post('/dform/index/getDangerWorkNum',{})
        .then((res) => {
          if(res.data.code){
            _that.menuList.forEach((item,index) => {
              _that.$set(_that.menuList[index],'num',res.data.data[item.value])
            })
          }
        })
      },
      toDangerWork(params){
        // sessionStorage.setItem('routeParams',JSON.stringify({name:params.label,codeName:params.value}))
        // this.$router.push({name:params.value});
				sessionStorage.setItem('routeParams', JSON.stringify({
					name: params.label,
					codeName: params.value
				}))
				this.$router.push({
					name: 'DHZYYDD',
				});
      }
    },

    computed: {
      ...mapState({
        leftTreeIndex: state => state.leftTreeIndex,
        rootMenuList: state => state.rootMenuList,
        leftTreeCodeName: state => state.leftTreeCodeName,
      }),
    },

    watch: {
      rootMenuList:{
        handler(val,oldVal){
          let _that = this
          if(val.length){
            _that.menuList = []
            val.forEach(item => {
              if(!item.default){
                _that.$set(_that.menuList,_that.menuList.length,item)
              }
            })
          }
        },
        deep: true,
        immediate: true
      }
    },

  }
</script>

<style lang="less" scoped>
  .navShow {
    background: linear-gradient(90deg, #3eb2e7, #05469c);
    width: 100%;
    height: 1.25rem;
    padding: 0.4rem 0;
    z-index: 1;
    .van-col{
      text-align: center;
      color: #fff;
      font-size: 0.45rem;
	  line-height: 1.25rem;
      font-weight: bold;
    }
  }
  .dangerWorkList{
    height: calc(100% - 1.25rem);
    background-color: rgb(227, 227, 227);
    .colContent{
      height: 100%;
      .dangerWork{
        border: 1px solid ccc;
        background-color: #fff;
        padding: 0.1rem;
        margin: 0.1rem;
        border-radius: 5px;
        height: 1rem;
        line-height: 1rem;
        font-weight: 500;
        font-size: 16px;
      }
    }
  }
  .itemDetail{
    float: right;
    height: 1rem;
    line-height: 1rem;
    padding: 0 4px;
    border-radius: 5px;
    cursor: pointer;
    margin: 0 0.1rem;
  }
</style>
